import React from 'react';
import { Route } from 'react-router-dom';

// Other main pages
const PickingPage = React.lazy(() => import('../pages/PickingPage').then(m => ({ default: m.PickingPage })));
const ManifestsPage = React.lazy(() => import('../pages/ManifestsPage').then(m => ({ default: m.ManifestsPage })));
const CustomersPage = React.lazy(() => import('../pages/CustomersPage').then(m => ({ default: m.CustomersPage })));
const ProductsPage = React.lazy(() => import('../pages/ProductsPage').then(m => ({ default: m.ProductsPage })));
const QuotesPage = React.lazy(() => import('../pages/QuotesPage').then(m => ({ default: m.QuotesPage })));
const InventoryDashboard = React.lazy(() => import('../pages/InventoryDashboard'));
const ReportsPage = React.lazy(() => import('../pages/ReportsPage').then(m => ({ default: m.ReportsPage })));
const FleetLiveMapPage = React.lazy(() => import('../pages/FleetLiveMapPage').then(m => ({ default: m.FleetLiveMapPage })));

// Detail pages
const CustomerDetailPage = React.lazy(() => import('../pages/CustomerDetailPage'));
const ProductDetailPage = React.lazy(() => import('../pages/ProductDetailPage'));

export const otherRoutes = [
  // Warehouse & Operations
  <Route key="/picking" path="/picking" element={<PickingPage />} />,
  <Route key="/manifests" path="/manifests" element={<ManifestsPage />} />,
  <Route key="/fleet-map" path="/fleet-map" element={<FleetLiveMapPage />} />,

  // Catalog
  <Route key="/customers" path="/customers" element={<CustomersPage />} />,
  <Route key="/customers/:customerId" path="/customers/:customerId" element={<CustomerDetailPage />} />,
  <Route key="/products" path="/products" element={<ProductsPage />} />,
  <Route key="/products/:productId" path="/products/:productId" element={<ProductDetailPage />} />,

  // Business
  <Route key="/quotes" path="/quotes" element={<QuotesPage />} />,
  <Route key="/inventory" path="/inventory" element={<InventoryDashboard />} />,
  <Route key="/reports" path="/reports" element={<ReportsPage />} />,
];
